import { ColumnDef } from '@tanstack/react-table'
import { GetPlayerTransactionsByIdData } from '@/modules/manage-player/type'
import { Badge } from '@/common/ui/badge'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { DepositStatus } from '@/schema'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'

export const transactionColumns: ColumnDef<GetPlayerTransactionsByIdData>[] = [
	{
		accessorKey: 'amount',
		header: 'ประเภท/จำนวนเงิน',
		cell: ({ row }) => (
			<div className="space-y-1">
				<Badge
					variant={row.original.type === 'DEPOSIT' ? 'default' : 'destructive'}
				>
					{row.original.type === 'DEPOSIT' ? 'ฝาก' : 'ถอน'}
				</Badge>
				<p className="font-medium">
					{row.original.amount.toLocaleString('th-TH')}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'promotionName',
		header: 'โปรโมชั่น/โบนัส',
		cell: ({ row }) => {
			const promotionNameRaw = row.original.promotionName
			const promotionName = promotionNameRaw ? String(promotionNameRaw) : ''
			return (
				<div className="space-y-1">
					<p>{promotionName || '-'}</p>
					<p className="text-xs text-muted-foreground">
						โบนัส: {row.original.bonusAmount?.toLocaleString() || '-'}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'status',
		header: 'สถานะ/เวลา',
		cell: ({ row }) => {
			const status = row.original.status
			const statusColors: Record<DepositStatus, string> = {
				CREATED: 'text-blue-500',
				PENDING: 'text-yellow-500',
				PROCESSING: 'text-amber-500',
				COMPLETED: 'text-green-500',
				FAILED: 'text-red-500',
				CANCELED: 'text-red-500',
				EXPIRED: 'text-gray-500',
				MANUAL_COMPLETED: 'text-green-500',
				PAYMENT_GATEWAY_FAILED: 'text-red-500',
			}
			return (
				<div className="space-y-1">
					<span className={statusColors[status]}>
						{status === 'CREATED' && 'สร้างแล้ว'}
						{status === 'PENDING' && 'รอดำเนินการ'}
						{status === 'PROCESSING' && 'กำลังตรวจสอบ'}
						{status === 'COMPLETED' && 'สำเร็จ'}
						{status === 'FAILED' && 'ไม่สำเร็จ'}
						{status === 'CANCELED' && 'ยกเลิก'}
						{status === 'EXPIRED' && 'หมดอายุ'}
						{status === 'MANUAL_COMPLETED' && 'รอ Payment Gateway ตรวจสอบ'}
						{status === 'PAYMENT_GATEWAY_FAILED' &&
							'กรุณาตรวจสอบกับ Payment Gateway'}
					</span>
					<p className="text-xs text-muted-foreground">
						ประเภท:{' '}
						{row.original.processor === 'AUTO'
							? 'ทำรายการอัตโนมัติ'
							: 'ทำรายการด้วยพนักงาน'}
					</p>
					<p className="text-xs text-muted-foreground">
						{format(new Date(row.original.createdAt || ''), 'PPP HH:mm น.', {
							locale: th,
						})}
					</p>
				</div>
			)
		},
	},
	{
		id: 'detail',
		header: 'การดำเนินการ',
		cell: ({ row }) => {
			const id = row.original.id
			const type = row.original.type
			const path = type === 'DEPOSIT' ? 'deposits' : 'withdraws'

			return (
				<Link to={`/operator/transactions/${path}/${id}`}>
					<Button variant="default">ดูรายละเอียด</Button>
				</Link>
			)
		},
	},
]
